import { render, staticRenderFns } from "./EditAccountComponent.vue?vue&type=template&id=e2bcce22"
import script from "./EditAccountComponent.vue?vue&type=script&lang=js"
export * from "./EditAccountComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports